// extracted by mini-css-extract-plugin
export var attachment = "_jh-a";
export var emailContainer = "_jh-4";
export var emailContentPaddedContainer = "_jh-b";
export var emailHeader = "_jh-6";
export var emailIframe = "_jh-3";
export var emailInfoIcon = "_jh-9";
export var emailShortenedSummary = "_jh-e";
export var infoDropdown = "_jh-0";
export var infoRowBoundedContent = "_jh-d";
export var internal = "_jh-5";
export var merchant = "_jh-8";
export var messageInputContainer = "_jh-h";
export var normal = "_jh-7";
export var replyCard = "_jh-f";
export var subtleButton = "_jh-1";
export var subtleButtonIconContainer = "_jh-2";
export var toggleViewRepliesButton = "_jh-c";
export var wrappingText = "_jh-g";